import { forwardRef, type Ref, type SVGProps } from "react";
const IconColorPickerOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M22.777 4.503a1 1 0 0 1 1.339-.07l.076.07 3.3 3.299.068.075c.32.393.298.973-.067 1.34l-2.067 2.068 1.537 1.537.064.079a.5.5 0 0 1-.064.629l-.708.707-.077.064a.5.5 0 0 1-.552 0l-.078-.064-1.535-1.537-13.04 13.063a1 1 0 0 1-.483.267l-4.288.99-.135.022a1.002 1.002 0 0 1-1.087-1.088l.02-.133.99-4.29c.032-.136.092-.265.175-.377l.092-.105 13.04-13.062-1.527-1.529-.065-.078a.5.5 0 0 1 .065-.629l.707-.707a.5.5 0 0 1 .629-.064l.078.064 1.526 1.527zM12.127 18l-4.252 4.26-.565 2.45 2.451-.565L15.895 18zm1.997-2h3.768l4.706-4.714-1.885-1.885zm8.002-8.014 1.886 1.885 1.36-1.361-1.886-1.886z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconColorPickerOutlineSVG);
ForwardRef.displayName = "IconColorPickerOutline";
export { ForwardRef as IconColorPickerOutline };
